import { useLocation, useHistory } from 'react-router-dom';

export const useRewardTabSync = () => {
  const location = useLocation();
  const history = useHistory();

  const getRewardTab = () => {
    const searchParams = new URLSearchParams(location.search);
    const rewardId = searchParams.get('rewardId');
    const rewardTab = searchParams.get('rewardTab');
    return {
      rewardId,
      rewardTab,
    };
  };

  const setRewardTab = (id, tab) => {
    const searchParams = new URLSearchParams(location.search);

    if (id) {
      searchParams.set('rewardId', id);
    } else {
      searchParams.delete('rewardId');
    }

    if (tab) {
      searchParams.set('rewardTab', tab);
    } else {
      searchParams.delete('rewardTab');
    }

    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  return {
    ...getRewardTab(),
    setRewardTab,
  };
};
